import { Component, OnInit, Input } from '@angular/core';
import { OpeningClosingHoursRequest, OpeningClosingHoursRequestSearch, OpeningClosingHoursType } from '../../../../../models/api-store/opening-closing-hours/opening-closing-hours.request.model';
import { HttpErrorResponse } from '@angular/common/http';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AppointmentOpeningClosingHoursService } from '../../../../../services/api-store/appointment-opening-closing-hours/appointment-opening-closing-hours.service';
import { FALSE, TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-appointment-times-edit',
  templateUrl: './appointment-times-edit.component.html'
})
export class AppointmentTimesEditComponent implements OnInit {

  @Input() storeId:number;
  @Input() type:string;


  //Tabella orari
  idOpeningclosinghours: number;
  isValidOpeningclosinghours:boolean = false;
  outputOpeningclosinghoursTable:any = {};
  inputOpeningclosinghoursTable:OpeningClosingHoursRequest;


  constructor(
    private appointmentOpeningClosingHoursService: AppointmentOpeningClosingHoursService,
    private spinner: SpinnerService,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.initOpeningClosingHours();
  }

  /**
   * Inizializza i dati della tabella orari
   */
  initOpeningClosingHours(){
    if(typeof this.storeId != typeof undefined){
      let openingClosingHoursRequestSearch = new OpeningClosingHoursRequestSearch();
      openingClosingHoursRequestSearch.storeId = this.storeId;
      openingClosingHoursRequestSearch.type = OpeningClosingHoursType[this.type];
      this.appointmentOpeningClosingHoursService.search(openingClosingHoursRequestSearch).subscribe(
        (response) => {
          if(response){
            if(response.total > 0){
              this.inputOpeningclosinghoursTable = response.data[0];
              this.idOpeningclosinghours = response.data[0].id;
            }else{
              this.inputOpeningclosinghoursTable = new OpeningClosingHoursRequest();
            }
          }
          this.spinner.hide();
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni' , 'Modifica orari custom', {
            timeOut: 5000
          });
          this.spinner.hide();
        }
      );
    }else{
      this.inputOpeningclosinghoursTable = new OpeningClosingHoursRequest();
    }  
  }

  /*  AZIONI */

  /**
   * Salva modifiche
   */
  saveOpeningclosinghours(){
    let request = this.outputOpeningclosinghoursTable;
    request.storeId = this.storeId;
    if(this.isValidOpeningclosinghours == TRUE){
      this.spinner.open();
      if(typeof this.idOpeningclosinghours != typeof undefined){
        //Update
        this.appointmentOpeningClosingHoursService.update(this.idOpeningclosinghours,request).subscribe(
          (response) => {
            if(response){
              this.toastr.success('Orari custom modificati con successo', 'Modifica orari custom');
              this.activeModal.close(response);
            }
            this.spinner.hide();
          },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.toastr.error('Si è verificato un errore durante la modifica degli orari custom' , 'Modifica orari custom fallita', {
              timeOut: 5000
            });
            this.spinner.hide();
          }
        );
      }else{
        //Create
        this.appointmentOpeningClosingHoursService.create(request).subscribe(
          (response) => {
            if(response){
              this.idOpeningclosinghours = response.id;
              this.toastr.success('Orari custom modificati con successo', 'Modifica orari custom');
              this.activeModal.close(response);
            }
            this.spinner.hide();
          },
          (error: HttpErrorResponse) => {
            console.log(error);
            this.toastr.error('Si è verificato un errore durante la modifica degli orari custom' , 'Modifica orari custom fallita', {
              timeOut: 5000
            });
            this.spinner.hide();
          }
        );
      }
    }
  }

  /**
   * Annulla
   */
  cancel(){
    this.activeModal.close('Close click');
  }

  /* AGGIORNA VALORI  */

  /**
   * Aggiorna valori della tabella orari
   * @param $event 
   */
  changeTableHours($event){
    if($event.status === "VALID"){
      this.isValidOpeningclosinghours = (TRUE && $event.touched);
    }else{
      this.isValidOpeningclosinghours = (FALSE && $event.touched);
    }
    this.outputOpeningclosinghoursTable = $event.output;
  }

}
